{
  "header.create": "إنشاء",
  "header.batch": "مجموعة",
  "header.privacyBadge": "بياناتك لا تغادر متصفحك أبداً",
  "header.offline": "بدون اتصال",
  "header.install": "تثبيت",
  "header.language": "اللغة",
  "header.theme": "المظهر",
  "theme.system": "النظام",
  "theme.light": "فاتح",
  "theme.dark": "داكن",
  "footer.privacy": "بياناتك لا تغادر متصفحك. تتم المعالجة محلياً.",
  "layout.narrowWarning": "للحصول على أفضل تجربة، استخدم شاشة بعرض 768 بكسل على الأقل.",
  "cancel": "إلغاء",
  "save": "حفظ",
  "meta.title": "ماما QR — مولد ومصمم رموز الاستجابة السريعة مجاناً",
  "meta.description": "أنشئ وصمم وحمل رموز الاستجابة السريعة مجاناً وبدون تتبع.",
  "header.brandName": "ماما QR",
  "header.srTitle": "مولد رمز الاستجابة السريعة مجاناً - ",
  "header.feedback": "الملاحظات والدعم",
  "qrupload.scan": "مسح ضوئي",
  "qrupload.notFound": "لم يتم العثور على رمز QR صالح في الصورة."
}